// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__31WXB","label":"Section_label__3uxm2","contentWrap":"Section_contentWrap__10Eco","footer":"Section_footer__O-h26","footerInner":"Section_footerInner__3ENaY"};